module.exports = __webpack_public_path__ + "static/media/parcela.39407fc5.png";